<template>
  <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
    <select
      v-model="status__"
      :disabled="!params.data.actionData.toggle"
      @change="
        handleStatusChnage(params.data.leads_id, params.data.status_list)
      "
      name="cars"
      id="cars"
      form="carform"
      class="w-100 selectExample mt-2 customSelect"
    >
      <option
        :key="index"
        :value="item.leads_status_id"
        :label="item.status_name"
        v-for="(item, index) in params.data.status_list"
        class="selectOptionclass"
      />
    </select>
  </vs-row>
</template>
<script>
import { change_leads_status } from '@/api/leads'

export default {
  data () {
    return {
      status__: null
    }
  },
  mounted () {
    this.status__ = this.params.data.leads_current_status_id
  },
  methods: {
    async handleStatusChnage (leads_id, status_list) {
      try {
        const currentStatusIndex = status_list.findIndex(item => item.leads_status_id === this.status__)
        const oldStatusID = this.params.data.leads_current_status_id
        const currentStatusOrderNumber = status_list[currentStatusIndex].status_sequence
        const payload = {
          leads_id,
          form_status_id: oldStatusID,
          to_status_id: this.status__,
          leads_status_order_number: currentStatusOrderNumber,
          customer_id: this.$store.state.LoginStorage.user_details.customer_id
        }
        if (this.params.data.is_converted === '1') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Lead already converted into student',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        } else {
          const { data } = await change_leads_status(payload)
          this.params.data.leads_current_status_id = this.status__
          this.$vs.notify({
            title: 'Success',
            text: data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        }
      } catch (e) {
        this.status__ = this.params.data.leads_current_status_id
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        console.error(e)
      }
    }
  }
}
</script>
<style scoped>
.customSelect {
  border-radius: 3px;
  border: 1px solid #cccccc;
  width: 100%;
  height: 30px;
  background-color: white;
  color: #757575;
  /* font-family: $font-family-base'; */
}
.selectOptionclass :hover {
  background-color: yellow;
  color: white;
  border: none;
}
</style>
